var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52571 1.50001L2.10488 5.12084C1.97571 5.25834 1.85071 5.52918 1.82571 5.71668L1.67154 7.06668C1.61738 7.55418 1.96738 7.88751 2.45071 7.80418L3.79238 7.57501C3.97988 7.54168 4.24238 7.40418 4.37154 7.26251L7.79238 3.64168C8.38404 3.01668 8.65071 2.30418 7.72988 1.43334C6.81321 0.570842 6.11738 0.875009 5.52571 1.50001Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95508 2.10425C5.13424 3.25425 6.06758 4.13341 7.22591 4.25008",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.16675H8.75",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen2);
export default __webpack_public_path__ + "static/media/pen2.9d27d03cd8df1bbbb13de32da2d421b7.svg";
export { ForwardRef as ReactComponent };